import makeEvent from './makeEvent';
import { FieldInputted, UseFieldEvents } from './types';
import { EVENTS } from './types/events';

type CartData = {
  brand?: string;
  sku?: string;
  name?: string;
  productType?: string;
};

const fieldEvents: UseFieldEvents = (
  data: FieldInputted & { cart?: CartData },
) => {
  const fieldEvent = makeEvent<FieldInputted, EVENTS>({
    ...data,
    formContext: {
      formBrand: data.cart?.brand,
      formId: data.cart?.sku,
      formName: data.cart?.name,
      formType: data.cart?.productType,
      ...data.formContext,
    },
  });

  return {
    fieldInputted: fieldEvent<FieldInputted>(EVENTS.FieldInputted),
  };
};

export default fieldEvents;
